import ApiService from '@/services/api.service'

const USER_ENTITY_KEY = 'user_entity'

const EntityService = {

	/**
	 * Retourne l'entité de l'utilisateur avec son id
	 * @param {Number} id identifiant de l'entité
	 */
	getUserEntity: async function(id) {
		
		let userEntity = sessionStorage.getItem(USER_ENTITY_KEY)

		if (userEntity) {
			userEntity = JSON.parse(userEntity)
		}

		if (!userEntity || userEntity.id !== id) {
			const response = await ApiService.get('/api/entities/' + id)
			userEntity = response.data
			sessionStorage.setItem(USER_ENTITY_KEY, JSON.stringify(userEntity))
		}

		return userEntity
	},
	
	/**
	 * Retourne l'entité pour l'id donné
	 * @param {Number} id identifiant de l'entité
	 */
	getEntity: async function(id) {
		
		const response = await ApiService.get('/api/entities/' + id)
		return response.data
	},

	/**
	 * Recherche les entités
	 * @param {Boolean} onlyValidDest Seulement les entités valides de type hopital
	 */
	getEntities: async function(onlyValidDest) {

		const params = onlyValidDest ? '?onlyValidDest=true' : ''
		const response = await ApiService.get('/api/entities' + params)
		return response.data
	},
	
	/**
	 * Retourne les utilisateurs de l'entité pour l'id donné
	 * @param {Number} id identifiant de l'entité
	 */
	getUsers: async function(id) {
		
		const response = await ApiService.get('/api/entities/' + id + '/users')
		return response.data
	},


	/**
	 * Retourne le nom de l'entité pour un id artemis
	 * @param {String} artemisEtareId id artemis de l'entité
	 */
	getNameByArtemisId: async function(artemisEtareId) {
		
		if (artemisEtareId) {
			const response = await ApiService.get('/api/entities/artemis/'+artemisEtareId)
			return response.data
		} else {
			return ''
		}
	},


	/**
	 * Mise à jour de l'entité
	 * 
	 * @param {Object} entity 
	 */
	updateEntity: async function(entity) {
		
		const response = await ApiService.post('/api/entities/'+ entity.id, entity)
		return response.data
	}
}

export default EntityService